import * as React from "react";
import Button from "@material-ui/core/Button";
import { TextField, Typography } from "@material-ui/core";
import { DubitoSvc } from "../api";
import { RouteProps } from "react-router";
import queryString from "query-string";
//import cookie from 'react-cookie'

interface Props extends RouteProps {}
export default class Login extends React.Component<Props> {
  state = {
    email: "",
    password: "",
    error: ""
  };
  login = () => {
    this.setState({ error: "" });
    const values = {
      email: this.state.email,
      password: this.state.password
    };
    if (values.email.length === 0 || values.password.length === 0) {
      return;
    }
    DubitoSvc.login(values)
      .then((res: any) => {
        if (res.success) {
          localStorage.setItem("id", res.id);
          localStorage.setItem("token", res.token);
          localStorage.setItem("role", res.role);
          localStorage.setItem("dubito/accountName", res.user.name);
          localStorage.setItem(
            "dubito/accountPicture",
            res.user.account_picture
          );
          const parsed = queryString.parse(this.props.location.search);

          if (parsed["redirect"]) {
            window.location.href = parsed["redirect"];
          } else {
            window.location.href = "/";
          }
        } else {
          this.setState({ error: res.msg });
        }
      })
      .catch(err => {
        this.setState({ error: "Login failed. Email or password incorrect" });
        console.log(err);
      });
  };
  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%",
          height: "50%"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            justifySelf: "center",
            maxWidth: 400
          }}
        >
          <div
            style={{
              marginLeft: 24,
              marginRight: 24
            }}
          >
            <Typography variant="display2">Dubito</Typography>
            <span style={{ marginTop: 16, color: "red" }}>
              {this.state.error}
            </span>
            <TextField
              fullWidth
              name="email"
              style={{ marginTop: 24 }}
              label="Email Address"
              onChange={e => {
                this.setState({ email: e.target.value });
              }}
            />
            <TextField
              name="password"
              type="password"
              fullWidth
              style={{ marginTop: 24 }}
              label="Password"
              onChange={e => {
                this.setState({ password: e.target.value });
              }}
            />
            <Button
              fullWidth
              style={{ marginTop: 24 }}
              variant="contained"
              color="primary"
              onClick={this.login}
            >
              Login
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/auth/login.tsx